import base from "../config/base.json";

var _settings: any = null;
const getSettings = () => {
  if(_settings !== null){
    return _settings
  }
  _settings = new Settings()
  console.log(_settings, "_settings")
  return _settings
}

class Settings {

  STORAGE_DEFAULT: string;
  STORAGE_ISMOR_CLIENT: string;
  STORAGE_ISMOR_DP: string;
  STORAGE_ISMOR_LESSON: string;
  STORAGE_ISMOR_PDFGEN: string;
  STORAGE_ISMOR_REDMINE: string;
  STORAGE_ISMOR_XD: string;
  FAST_API: string; 

  API_HOST: string;
  WS_HOST: string;
  STATIC_HOST: string;
  WEB_RTC: string;
  APP_NAME: string;
  USERNAME_PASSWORD_LOGIN: string;
  PENTA_ACC_FACEBOOK_LOGIN: string;
  PENTA_ACC_LINE_LOGIN: string;
  PENTA_ACC_EMAIL_LOGIN: string;
  APPOINTMENT_CHAT_FUNCTION: string;
  BOOKING_FUNCTION: string;
  DASHBOARD: string;
  FORM_ANALYTICS: string;
  WEB_PUSH_PUBLIC_KEY: string;
  LATEST_ENCOUNTER_TOP: string;
  HIDE_QUEUE_FILTER_DATE: string;
  USE_PAYMENT_STATUS_LABEL: string;
  OPEN_FORM_ENCOUNTER: string;
  IGNORE_CAN_CHAT: string;
  HIDE_CALL_BUTTON: string;
  QUEUE_API_V2: string;
  HIDE_QUEUE: string;
  HIDE_SIDEBAR: string;
  HIDE_DIVISION: string;
  HIDE_NOTE: string;
  HIDE_CLASSIFY: string;
  COMPANY: string;
  PROJECT: string;
  SETTINGS: string;
  STUDIO: string;
  FIREBASE_PROJECTS: string[];
  

  // Change window to globalThis so for testing in node
  constructor(domain: string) {

    // กันไม่ให้พลาดตรง config.ts
    if (process.env.NODE_ENV === "production") {
      domain = globalThis.location ? globalThis.location.hostname : "localhost";
    } else { 
      // domain = "ismor.mor.company"
      domain = "ismor.web.app"
    }

    const favor = this.selectDomain(domain);
    
    this.STORAGE_DEFAULT = favor.STORAGE_DEFAULT ?? ""
    this.STORAGE_ISMOR_CLIENT = favor.STORAGE_ISMOR_CLIENT ?? ""
    this.STORAGE_ISMOR_DP = favor.STORAGE_ISMOR_DP ?? ""
    this.STORAGE_ISMOR_LESSON = favor.STORAGE_ISMOR_LESSON ?? ""
    this.STORAGE_ISMOR_PDFGEN = favor.STORAGE_ISMOR_PDFGEN ?? ""
    this.STORAGE_ISMOR_REDMINE = favor.STORAGE_ISMOR_REDMINE ?? ""
    this.STORAGE_ISMOR_XD = favor.STORAGE_ISMOR_XD ?? ""

    // url of api server
    this.API_HOST = favor.API_HOST || globalThis.location.origin;

    this.FAST_API = favor.FAST_API === undefined ? "" : favor.FAST_API;
    
    // websocket server host name
    this.WS_HOST = favor.WS_HOST || globalThis.location.hostname;
    // static host for api such as TRIAGE_LEVEL_CLASSIFY
    this.STATIC_HOST = favor.STATIC_HOST || 'https://admin.ishealth.app';
    // host of web rtc server
    this.WEB_RTC = favor.WEB_RTC || 'https://webrtc.drjaysayhi.com';

    this.APP_NAME = favor.APP_NAME || 'ishealth';

    this.USERNAME_PASSWORD_LOGIN = favor.USERNAME_PASSWORD_LOGIN === undefined ?
      true : favor.USERNAME_PASSWORD_LOGIN;

    // Enable accounts.thevc authentication options
    this.PENTA_ACC_FACEBOOK_LOGIN = favor.PENTA_ACC_FACEBOOK_LOGIN === undefined ?
      true : favor.PENTA_ACC_FACEBOOK_LOGIN;
    this.PENTA_ACC_LINE_LOGIN = favor.PENTA_ACC_LINE_LOGIN === undefined ?
      true : favor.PENTA_ACC_LINE_LOGIN;
    this.PENTA_ACC_EMAIL_LOGIN = favor.PENTA_ACC_EMAIL_LOGIN === undefined ?
      true : favor.PENTA_ACC_EMAIL_LOGIN;

    this.APPOINTMENT_CHAT_FUNCTION = favor.APPOINTMENT_CHAT_FUNCTION === undefined ?
        false : favor.APPOINTMENT_CHAT_FUNCTION;

    // Booking function
    this.BOOKING_FUNCTION = favor.BOOKING_FUNCTION === undefined ?
      true : favor.BOOKING_FUNCTION;

    // Dashboard
    this.DASHBOARD = favor.DASHBOARD === undefined ?
      true : favor.DASHBOARD;
    
    this.FORM_ANALYTICS = favor.FORM_ANALYTICS === undefined ?
      true : favor.FORM_ANALYTICS;

    this.SETTINGS = favor.SETTINGS === undefined ?
      true : favor.SETTINGS;

    this.STUDIO = favor.STUDIO === undefined ?
      false : favor.STUDIO;

    // Webpush
    this.WEB_PUSH_PUBLIC_KEY = favor.WEB_PUSH_PUBLIC_KEY ||
      "BDKyMQyvGoPQ5LvRPBmQGec1_geS441vKvkdYhaNM4WDfd0a403b0BTunKNBST_-mcaR5at3B8FYL-N4xo4x9a0";

    this.LATEST_ENCOUNTER_TOP = favor.LATEST_ENCOUNTER_TOP === undefined ?
      false : favor.LATEST_ENCOUNTER_TOP;

    this.HIDE_QUEUE_FILTER_DATE = favor.HIDE_QUEUE_FILTER_DATE === undefined ? false : favor.HIDE_QUEUE_FILTER_DATE;
    
    this.USE_PAYMENT_STATUS_LABEL = favor.USE_PAYMENT_STATUS_LABEL === undefined ? false : favor.USE_PAYMENT_STATUS_LABEL;

    this.OPEN_FORM_ENCOUNTER = favor.OPEN_FORM_ENCOUNTER === undefined ? true : favor.OPEN_FORM_ENCOUNTER

    this.IGNORE_CAN_CHAT = favor.IGNORE_CAN_CHAT === undefined ? false : favor.IGNORE_CAN_CHAT

    this.HIDE_CALL_BUTTON = favor.HIDE_CALL_BUTTON === undefined ? false : favor.HIDE_CALL_BUTTON

    // api V2 for penguin
    this.QUEUE_API_V2 = favor.QUEUE_API_V2 === undefined ? false :favor.QUEUE_API_V2

    // ---------------------------------- for CNMI telemed ----------------------------------
    this.HIDE_QUEUE = favor.HIDE_QUEUE === undefined ? false : favor.HIDE_QUEUE

    this.HIDE_SIDEBAR = favor.HIDE_SIDEBAR === undefined ? false : favor.HIDE_SIDEBAR

    this.HIDE_DIVISION = favor.HIDE_DIVISION === undefined ? false : favor.HIDE_DIVISION

    this.HIDE_NOTE = favor.HIDE_NOTE === undefined ? false : favor.HIDE_NOTE

    this.HIDE_CLASSIFY = favor.HIDE_CLASSIFY === undefined ? false : favor.HIDE_CLASSIFY
    // --------------------------------------------------------------------------------------

    this.COMPANY = favor.COMPANY === undefined ? "" : favor.COMPANY

    this.PROJECT = favor.PROJECT === undefined ? "" : favor.PROJECT

    this.FIREBASE_PROJECTS = favor.FIREBASE_PROJECTS === undefined ? [] : favor.FIREBASE_PROJECTS
    
    // console.log(`Settings for ${domain}`);
    // console.log(this);
  }

  selectDomain(domain: string) {
    if (domain in base) {
      return (base as {[key: string]: any})[domain]
    } else if (!('default' in base)) {
      throw `cannot find "${domain}" or "default" in settings`
    }
    return base.default
  }
}

// export default new Settings();
export default getSettings();